webpackJsonp([78466907431745],{

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Head = __webpack_require__(17);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _contact = __webpack_require__(18);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Next - Why Us' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero is-relative is-theme-secondary hero-waves' },
	      _react2.default.createElement(_Head2.default, null),
	      _react2.default.createElement(
	        'div',
	        { id: 'main-hero', className: 'hero-body ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered is-tablet-portrait' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-7 header-caption has-text-left' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'landing-title' },
	                'Our mission is to increase your potential'
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'subtitle is-7 light-text' },
	                'Next Software is a technology company that builds infrastructure for the companies. Businesses of every size\u2014from new startups to public companies\u2014use our services to build and manage their businesses online.',
	                ' '
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'pt-10 pb-10' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#contact-form', className: 'button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2' },
	                  'Hire Us'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-9 is-offset-1 is-hidden-mobile' },
	              _react2.default.createElement('figure', { className: 'image is-4by3 reactjs-logo' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'features', className: 'section section-feature-grey is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container has-text-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title-wrapper has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-number' },
	            '1'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title-landing' },
	            'Transparency'
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'WE GIVE YOU REASONS TO CHOOSE NEXT.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered has-text-centered' },
	            _react2.default.createElement('div', { className: 'column is-hidden-mobile' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing secondary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'fas fa-stopwatch' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'EXCELLENT ADMINISTRTION AND ATTAINMENT'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'The main focus of our team is to solve your problems quickly and effectively and ensuring that your project is completed on time and that too with minimum budget possible.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing secondary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'far fa-edit' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'EVOLVE IN OUR AREA'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'Next not only provides access to best resources but also renews it technologies from time to time to provide you with best outcomes.',
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing primary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'fas fa-headset' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'PERFECT TOOLS FOR THE RIGHT JOB'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'Our engineers know how difficult it is to work with new tools technologies each and every time, so we make sure that including our team, you are also updated regarding each and every tool and technology.',
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'column is-hidden-mobile' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_contact2.default, null)
	  );
	}
	// import Img from 'gatsby-image';
	
	
	Template.propTypes = {
	  data: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-us-jsx-9c992dd7ff516b125934.js